import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { BUSINESS } from "@/data/content";

/**
 * Slim scroll-triggered CTA strip pinned to the top of the viewport.
 * Appears after the visitor scrolls past 240px (i.e. after the hero CTA
 * is no longer in view) and disappears when scrolled back to the top.
 * Desktop-only — mobile already has a sticky bottom bar via MobileCTABar.
 *
 * 2026 modernization brief: "Sticky header CTA: po 200px scroll pojawia się
 * cienki pasek na górze z numerem telefonu i przyciskiem Free Estimate."
 */
export function ScrollCTABar() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    let raf = 0;
    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        setVisible(window.scrollY > 240);
        raf = 0;
      });
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return (
    <div
      className={`hidden lg:block fixed top-0 left-0 right-0 z-[55] bg-bg-dark text-white border-b border-white/10 shadow-lg transition-transform duration-300 ${
        visible ? "translate-y-0" : "-translate-y-full"
      }`}
      data-testid="scroll-cta-bar"
      aria-hidden={!visible}
    >
      <div className="container-x flex items-center justify-between h-12 text-sm">
        <div className="flex items-center gap-6 text-white/90">
          <span className="font-heading font-bold tracking-tight">Goral Construction LLC</span>
          <span className="text-white/60 hidden xl:inline">Licensed roofing contractor · Oakland County, MI</span>
        </div>
        <div className="flex items-center gap-4">
          <a
            href={`tel:${BUSINESS.phoneTel}`}
            className="inline-flex items-center gap-2 text-white hover:text-brand transition-colors font-semibold"
            aria-label={`Call Goral Construction ${BUSINESS.phone}`}
            data-testid="scroll-cta-phone"
          >
            <Phone className="w-4 h-4" />
            {BUSINESS.phone}
          </a>
          <Link
            to="/get-estimate"
            className="inline-flex items-center gap-2 bg-brand hover:bg-brand-deep text-white font-bold text-xs uppercase tracking-wider px-4 py-2 rounded-sm transition-colors"
            data-testid="scroll-cta-estimate"
          >
            Free Estimate <ArrowRight className="w-3.5 h-3.5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
